import React from 'react';
import ArticleIntro from './ArticleIntro';
import ArticleTableOfContent from './ArticleTableOfContent';
import ArticleCTA from './ArticleCTA';
import ArticleContactUs from './ArticleContactUs';
import ArticleLink from './ArticleLink';

interface GetHelpLayoutProps {
  isMobile: boolean;
  intro?: string;
  introClassname?: string;
  tableOfContent?: object;
  children: React.ReactNode;
  childrenMobile: React.ReactNode;
  buttonContent?: object;
  linkContent?: object;
  contactUsContent?: object;
}

const GetHelpLayout: React.FC<GetHelpLayoutProps> = ({
  isMobile,
  intro,
  introClassname,
  tableOfContent,
  children,
  childrenMobile,
  buttonContent,
  linkContent,
  contactUsContent,
}) => (
  <div>
    {isMobile ? (
      <div className="mobile-articlebody-section pb-2">
        <div className="mx-auto max-w-88p pt-3 pb-2">
          {intro && (
            <ArticleIntro
              introContent={intro}
              introClassname={introClassname}
            />
          )}
          {tableOfContent && (
            <ArticleTableOfContent
              tableOfContent={tableOfContent}
              isMobile={isMobile}
            />
          )}
        </div>
        <div className="articlebody-section w-full px-2h text-left">
          {childrenMobile}
        </div>
        {linkContent && (
          <ArticleLink linkContent={linkContent} />
        )}
        {buttonContent && (
          <ArticleCTA buttonContent={buttonContent} />
        )}
        {contactUsContent && (
          <ArticleContactUs contactUsContent={contactUsContent} />
        )}
      </div>
    ) : (
      <div className="desktop-articlebody-section mx-auto flex w-full flex-col items-center 2xl:max-w-80p">
        <div className="flex justify-between px-2 py-1 lg:px-3h">
          <div className="desktop-articlebody-section-left w-7/12 lg:w-7/12 2lg:w-8/12 xl:w-8/12 2xl:w-8/12 3xl:w-8/12">
            {intro && (
              <ArticleIntro
                introContent={intro}
                introClassname={introClassname}
              />
            )}
            <div className="articlebody-section">{children}</div>
            {linkContent && (
              <ArticleLink linkContent={linkContent} />
            )}
            {buttonContent && (
              <ArticleCTA buttonContent={buttonContent} />
            )}
            {contactUsContent && (
              <ArticleContactUs contactUsContent={contactUsContent} />
            )}
          </div>
          <div className="desktop-articlebody-section-right w-5/12 pl-1 sm:py-2 md:py-4 lg:w-5/12 lg:pl-7 2lg:w-4/12 xl:w-4/12 xl:pl-10 2xl:w-4/12 2xl:pl-15 3xl:w-4/12 3xl:pl-20">
            {tableOfContent && (
              <ArticleTableOfContent
                tableOfContent={tableOfContent}
                isMobile={isMobile}
              />
            )}
          </div>
        </div>
      </div>
    )}
  </div>
);

export default GetHelpLayout;